// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1PGTG","name":"ConsentHeader_name__GV5sR","birthday":"ConsentHeader_birthday__3R1m_","skeleton":"ConsentHeader_skeleton__2RJRb"};